const Cv = ({ values, handleChange }) => {
    return (
        <div>
            <div className="custom-file-input">
                <input
                    type="file"
                    accept='application/pdf'
                    name="cv"
                    id="cv"
                    onChange={handleChange('cv')}
                    className="file-input-hidden"
                />
                <label htmlFor="cv" className="btn-file-cv">
                    Choisir un fichier
                </label>
                {values.cv && (
                    <span className="file-name ms-2">{values.cv.name}</span>
                )}
            </div>
        </div>
    )
}

export default Cv;
